"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLikeWalletAddress = exports.changeAddressPrefix = exports.isValidAddress = void 0;
const bech32_1 = require("bech32");
function isValidAddress(address) {
  try {
    bech32_1.bech32.decode(address);
    return true;
  } catch (error) {
    return false;
  }
}
exports.isValidAddress = isValidAddress;
function changeAddressPrefix(address, newPrefix) {
  const {
    words
  } = bech32_1.bech32.decode(address);
  return bech32_1.bech32.encode(newPrefix, words);
}
exports.changeAddressPrefix = changeAddressPrefix;
function getLikeWalletAddress(id) {
  const addressLengthWithoutPrefixAnd1 = 38;
  let add = id;
  let likeWallet = null;
  if (id.startsWith('did:like:')) {
    add = `like1${id.slice(id.length - addressLengthWithoutPrefixAnd1)}`;
  } else if (id.startsWith('did:cosmos:')) {
    add = `cosmos1${id.slice(id.length - addressLengthWithoutPrefixAnd1)}`;
  }
  if (isValidAddress(add)) {
    likeWallet = changeAddressPrefix(add, 'like');
  }
  return likeWallet;
}
exports.getLikeWalletAddress = getLikeWalletAddress;